<template>
  <div class="footer">
    <div class="henkel">
      <img src="../../assets/henkel.png" v-bind:srcset="hk2x+' 2x'"/>
    </div>

    <div class="tabs">
      <div>
        <router-link to="/terms">
          使用條款
        </router-link>
      </div>

      <div>
        <router-link to="/privacy">
          私隱權守則
        </router-link>
      </div>
    </div>

    <div class="copyright">
      © 2018 - 2022 Henkel
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
      hk2x: require('../../assets/henkel@2x.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import "../../styles/_vars.sass"

.footer
  background-color: $footer-bg
  padding: 25px
  text-align: center
  color: #333333

  .henkel
    width: 91px
    margin: auto

  .tabs
    width: 168px
    margin: auto
    font-size: 14px
    margin-top: 17px
    overflow: auto

    div:first-child
      float: left
    
    div:last-child
      float: right
  
  .copyright
    margin: auto
    margin-top: 11px

</style>



// WEBPACK FOOTER //
// Footer.vue?a454df62